<template>
  <div class="sj-autocomplete-item" v-if="data && !data.hide">
    <template v-if="hasChild">
      <div
        class="sj-autocomplete-item-category"
        :style="paddingStyle"
        :label="data.label"
        @click.stop
      >
        {{ data.label }}
      </div>
      <AutoCompleteItem
        v-for="(item, index) in data.options"
        :value="value"
        :multiple="multiple"
        :showIcon="showIcon"
        :key="`item${index}`"
        :data="item"
        :level="level + 1"
        @change="emitChange"
      ></AutoCompleteItem>
    </template>
    <div
      v-else
      class="sj-autocomplete-item-inner"
      :class="{
        selected: reverseSelect ? !selected : selected,
        disabled: data.disabled || data.limit
      }"
      :style="paddingStyle"
      @click.stop="handleChange"
      :title="data.limit ? limitText : ''"
    >
      <SjImage
        v-if="showIcon"
        class="sj-autocomplete-item-icon"
        round
        :src="data.icon"
        :label="data.label"
      ></SjImage>
      <div class="sj-autocomplete-item-label" :title="data.label">
        {{ data.label }}
      </div>
      <SjCheckbox
        v-if="multiple"
        :value="reverseSelect ? !selected : selected"
        :disabled="data.disabled || data.limit"
        size="mini"
        @change="handleChange"
      ></SjCheckbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutoCompleteItem",
  props: {
    value: {},
    data: {
      type: Object,
      default: () => {}
    },
    level: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    limitText: {
      type: String,
      default: ""
    },
    reverseSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      padding: 10
    };
  },
  computed: {
    hasChild() {
      const { data } = this;
      return data && data.options && Array.isArray(data.options);
    },
    paddingStyle() {
      const { level, padding } = this;
      return {
        padding: `0 ${padding}px`,
        paddingLeft: `${level * padding}px`
      };
    },
    selected() {
      const { data, value, multiple, hasChild } = this;
      if (hasChild) {
        return false;
      }
      if (multiple) {
        return Array.isArray(value) && value.includes(data.value);
      }
      return value === data.value;
    }
  },
  methods: {
    handleChange() {
      const { data, value, selected, multiple } = this;
      if (data.disabled || data.limit) {
        return;
      }
      let newValue = multiple ? [] : data.value;
      if (multiple) {
        if (selected) {
          for (let i = 0; i < value.length; i += 1) {
            if (value[i] !== data.value) {
              newValue.push(value[i]);
            }
          }
        } else {
          newValue = value ? [...value] : [];
          newValue.push(data.value);
        }
      }
      this.emitChange(newValue);
    },
    emitChange(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style lang="less" scoped>
.sj-autocomplete-item {
  text-align: left;
  .sj-autocomplete-item-category {
    height: 30px;
    .text("tiny", "light", "light");
    line-height: 30px;
    .text-ellipsis();
  }
  .sj-autocomplete-item-inner {
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      background-color: @color-gray-2;
      .sj-autocomplete-item-label {
        color: @color-available;
      }
    }
    &.disabled {
      cursor: not-allowed;
      .sj-autocomplete-item-label {
        color: @color-light;
      }

      /deep/ .sj-checkbox-box {
        background-color: @color-gray-2;
        border-color: @color-gray-3;
      }
    }
    &.selected {
      .sj-autocomplete-item-label {
        color: @color-available;
      }
    }
    .sj-autocomplete-item-icon {
      flex-shrink: 0;
      margin-right: 5px;
      width: 24px !important;
      height: 24px !important;
    }
    .sj-autocomplete-item-label {
      flex-grow: 1;
      min-width: 0;
      .text-ellipsis();
      .text("caption", "normal");
    }
    .sj-autocomplete-item-checkbox {
      flex-shrink: 0;
      margin-left: 5px;
    }
  }
}
</style>
